export const data = {
  name: "Abtak Media",
  text1: "2 times",
  text2: "1 મહિના પહેલા",
  imgSrc: "https://i.ibb.co/ZHTYpHP/fb.png",
  details: {
    title: "# પંચાંગ",
    hash1: "@ShareChat Pramukh",
    hash2: " @ShareChat Gujarati"
  }
};
